import { FormField } from "@jugl-web/rest-api";
import { FieldValues } from "react-hook-form";
import { customerPhoneStringToInputValue } from "@jugl-web/ui-kit";

export const processCustomerFormsToApi = (
  formFieldsData: FormField[],
  data: FieldValues
) => {
  const dataKeys = Object.keys(data);
  return dataKeys
    .filter((key: string) => {
      const fieldData = formFieldsData.find(
        (formField) => formField.id === key
      );
      if (fieldData?.type === "mobile") {
        const phoneValue = customerPhoneStringToInputValue(data[key]);
        if (phoneValue.phone) {
          return fieldData;
        }
        return null;
      }
      return fieldData;
    })
    .map((key: string) => {
      return {
        field_id: key,
        value: data[key]?.trim() || null,
      };
    });
};
